<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
	<div class="flex-row flex-wrap w-100">
		<span class="w-100">Executing moovs: {{moovExecutionStatusResponse.executingMoovs}}</span>
		<span class="w-100">Invoked by user: {{invokedByUser}}</span>
		<span class="w-100">moov instances running late: {{moovExecutionStatusResponse.moovInstancesRunningLate}}</span>
		<span class="w-100">premier services running late: {{moovExecutionStatusResponse.premierServicesRunningLate}}</span>
	</div>
</mat-dialog-content>

<mat-dialog-actions >
	<div class="w-100 flex-row space-between items-center mt-3 p-2">
		<a mat-button class="dialog-btn" color="primary" (click)="onConfirmClick()"><span class="text-bold">{{confirmButtonText}}</span></a>
		<a mat-button class="dialog-btn mr-5" color="primary" (click)="onCancelClick()" ><span class="text-bold">{{cancelButtonText}}</span></a>
	</div>
</mat-dialog-actions>
